/* eslint-disable @typescript-eslint/no-explicit-any */
import { Dispatch } from 'redux';
import { AxiosResponse } from "axios";
import { 
    ThunkResult } from "./actionResultTypes";
import { 
    Action as InvoiceAction,
    ActionType as InvoiceActionType, 
    IFetchInvoices,
    IFetchInvoicesSuccess,
    IFetchInvoicesFail,
    IEditInvoice,
    IEditInvoiceSuccess,
    IEditInvoiceFail,
    IDeleteInvoice,
    IDeleteInvoiceSuccess,
    IDeleteInvoiceFail,
    IFetchInvoiceReport1,
    IFetchInvoiceReport1Success,
    IFetchInvoiceReport1Fail,
    IFetchInvoiceReport2,
    IFetchInvoiceReport2Success,
    IFetchInvoiceReport2Fail,
    IFetchInvoiceFCReport1,
    IFetchInvoiceFCReport1Success,
    IFetchInvoiceFCReport1Fail,
    IFetchInvoiceFCReport2,
    IFetchInvoiceFCReport2Success,
    IFetchInvoiceFCReport2Fail,    
} from "../actionTypes/invoiceActionTypes";
import { toastError, 
     toastSuccess 
} from '../../services/toasters';
import { 
    IInvoice as Invoice, 
    IRequestInvoiceR,
    IRequestInvoiceFC,
    IInvoiceReport1,
    IInvoiceReport2,
    IInvoiceFCReport1,
    IInvoiceFCReport2,    
} from '../../models/invoice';

import { httpGenerator } from '../../services';
import { MultiResponseType } from '../../models/multiResponseType';
import { IRequestReadReport } from '../../models/reportVisit';
import { SingleResponseType } from '../../models/singleResponseType';


export const GetInvoice = (request: IRequestReadReport): ThunkResult<void> => async (dispatch: Dispatch<InvoiceAction>) => { 
    dispatch<IFetchInvoices>({  
        type: InvoiceActionType.FETCH_INVOICES
    });

    try {
        const authToken = sessionStorage.getItem("token")
        const response: AxiosResponse<MultiResponseType<Invoice>> = await httpGenerator(authToken!).post(`invoices/contractMonthList/`, request);
        dispatch<IFetchInvoicesSuccess>({
            type: InvoiceActionType.FETCH_INVOICES_SUCCESS,
            payload: response.data
        });

    } catch(err: any) {
        dispatch<IFetchInvoicesFail>({
            type: InvoiceActionType.FETCH_INVOICES_FAIL,
            payload: err
        });
        console.log('err: ', err)
        toastError("خطا در بازیابی اطلاعات");
    }
}

export const GetInvoiceReport1 = (contractId: number, dateId: number): ThunkResult<void> => async (dispatch: Dispatch<InvoiceAction>) => { 
    dispatch<IFetchInvoiceReport1>({  
        type: InvoiceActionType.FETCH_INVOICEREPORT1
    });

    try {
        const authToken = sessionStorage.getItem("token")
        const response: AxiosResponse<SingleResponseType<IInvoiceReport1>> = await httpGenerator(authToken!).get(`invoices/contractMonthReportList1/${contractId}/${dateId}`);
        dispatch<IFetchInvoiceReport1Success>({
            type: InvoiceActionType.FETCH_INVOICEREPORT1_SUCCESS,
            payload: response.data,
        });

    } catch(err: any) {
        dispatch<IFetchInvoiceReport1Fail>({
            type: InvoiceActionType.FETCH_INVOICEREPORT1_FAIL,
            payload: err
        });
        console.log('err: ', err)
        toastError("خطا در بازیابی اطلاعات");
    }
}

export const GetInvoiceReport2 = (contractId: number, dateId: number): ThunkResult<void> => async (dispatch: Dispatch<InvoiceAction>) => { 
    dispatch<IFetchInvoiceReport2>({  
        type: InvoiceActionType.FETCH_INVOICEREPORT2
    });

    try {
        const authToken = sessionStorage.getItem("token")
        const response: AxiosResponse<MultiResponseType<IInvoiceReport2>> = await httpGenerator(authToken!).get(`invoices/contractMonthReportList2/${contractId}/${dateId}`);
        dispatch<IFetchInvoiceReport2Success>({
            type: InvoiceActionType.FETCH_INVOICEREPORT2_SUCCESS,
            payload: response.data,
        });

    } catch(err: any) {
        dispatch<IFetchInvoiceReport2Fail>({
            type: InvoiceActionType.FETCH_INVOICEREPORT2_FAIL,
            payload: err
        });
        console.log('err: ', err)
        toastError("خطا در بازیابی اطلاعات");
    }
}

export const GetInvoiceFCReport1 = (contractId: number, dateId: number): ThunkResult<void> => async (dispatch: Dispatch<InvoiceAction>) => { 
    dispatch<IFetchInvoiceFCReport1>({  
        type: InvoiceActionType.FETCH_INVOICEFCREPORT1
    });

    try {
        const authToken = sessionStorage.getItem("token")
        const response: AxiosResponse<SingleResponseType<IInvoiceFCReport1>> = await httpGenerator(authToken!).get(`invoices/contractMonthFCReportList1/${contractId}/${dateId}`);
        dispatch<IFetchInvoiceFCReport1Success>({
            type: InvoiceActionType.FETCH_INVOICEFCREPORT1_SUCCESS,
            payload: response.data,
        });

    } catch(err: any) {
        dispatch<IFetchInvoiceFCReport1Fail>({
            type: InvoiceActionType.FETCH_INVOICEFCREPORT1_FAIL,
            payload: err
        });
        console.log('err: ', err)
        toastError("خطا در بازیابی اطلاعات");
    }
}

export const GetInvoiceFCReport2 = (contractId: number, dateId: number): ThunkResult<void> => async (dispatch: Dispatch<InvoiceAction>) => { 
    dispatch<IFetchInvoiceFCReport2>({  
        type: InvoiceActionType.FETCH_INVOICEFCREPORT2
    });

    try {
        const authToken = sessionStorage.getItem("token")
        const response: AxiosResponse<MultiResponseType<IInvoiceFCReport2>> = await httpGenerator(authToken!).get(`invoices/contractMonthFCReportList2/${contractId}/${dateId}`);
        dispatch<IFetchInvoiceFCReport2Success>({
            type: InvoiceActionType.FETCH_INVOICEFCREPORT2_SUCCESS,
            payload: response.data,
        });

    } catch(err: any) {
        dispatch<IFetchInvoiceFCReport2Fail>({
            type: InvoiceActionType.FETCH_INVOICEFCREPORT2_FAIL,
            payload: err
        });
        console.log('err: ', err)
        toastError("خطا در بازیابی اطلاعات");
    }
}

export const EditInvoiceR = (id: number, request: IRequestInvoiceR): ThunkResult<void> => async (dispatch: Dispatch<InvoiceAction>) => { 
    dispatch<IEditInvoice>({ 
        type: InvoiceActionType.EDIT_INVOICE 
    });
    try {
        const authToken = sessionStorage.getItem("token")
        const response: AxiosResponse<Invoice> = await httpGenerator(authToken!).put(`invoices/${id}/`, request);
        dispatch<IEditInvoiceSuccess>({ 
            type: InvoiceActionType.EDIT_INVOICE_SUCCESS, 
            payload: response.data
        });
        toastSuccess("اطلاعات مورد نظر با موفقیت ویرایش گردید");

    } catch (err: any) {
        dispatch<IEditInvoiceFail>({ 
            type: InvoiceActionType.EDIT_INVOICE_FAIL,
            payload: err
        });
        console.log('err: ', err)
        toastError("خطا در ویرایش اطلاعات مورد نظر");
    }
};

export const EditInvoiceFC = (id: number, request: IRequestInvoiceFC): ThunkResult<void> => async (dispatch: Dispatch<InvoiceAction>) => { 
    dispatch<IEditInvoice>({ 
        type: InvoiceActionType.EDIT_INVOICE 
    });
    try {
        const authToken = sessionStorage.getItem("token")
        const response: AxiosResponse<Invoice> = await httpGenerator(authToken!).put(`invoices/${id}/`, request);
        dispatch<IEditInvoiceSuccess>({ 
            type: InvoiceActionType.EDIT_INVOICE_SUCCESS, 
            payload: response.data
        });
        toastSuccess("اطلاعات مورد نظر با موفقیت ویرایش گردید");

    } catch (err: any) {
        dispatch<IEditInvoiceFail>({ 
            type: InvoiceActionType.EDIT_INVOICE_FAIL,
            payload: err
        });
        console.log('err: ', err)
        toastError("خطا در ویرایش اطلاعات مورد نظر");
    }
};

export const DeleteInvoice = (deletedId: number): ThunkResult<void> => async (dispatch: Dispatch<InvoiceAction>) => { 
    dispatch<IDeleteInvoice>({ type: InvoiceActionType.DELETE_INVOICE });
    try {
        const authToken = sessionStorage.getItem("token")
        await httpGenerator(authToken!).delete(`invoices/${deletedId}/`);
        dispatch<IDeleteInvoiceSuccess>({
            type: InvoiceActionType.DELETE_INVOICE_SUCCESS,
            payload: deletedId
        });
        toastSuccess("اطلاعات مورد نظر با موفقیت حذف گردید");

    } catch (err: any) {
        dispatch<IDeleteInvoiceFail>({ 
            type: InvoiceActionType.DELETE_INVOICE_FAIL,
            payload: err
        });
        console.log('err: ', err)
        toastError("خطا در خذف اطلاعات مورد نظر");
    }
};